<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6.69995" cy="6" r="5" fill="#FAFAFA"/>
    <circle cx="6.69995" cy="6" r="4.5" stroke="#121F3A" stroke-opacity="0.5"/>
</svg>
